import type { Ref } from "react";
import { View as RNView } from "react-native";

import { Text, TextProps } from "@/components";

interface SectionHeaderProps {
  ref?: Ref<RNView>;
  textInPrimaryColor?: string;
  textInBrandColor?: string;
}

function SectionHeader({
  ref,
  textInPrimaryColor,
  textInBrandColor,
  ...textProps
}: SectionHeaderProps & TextProps) {
  return (
    <RNView ref={ref}>
      {textInPrimaryColor && (
        <Text
          {...textProps}
          size="$xxl"
          semibold
          $xl={{ size: 40, semibold: true }}
        >
          {textInPrimaryColor}
          {textInBrandColor && (
            <Text
              size="$xxl"
              $xl={{ size: 40, semibold: true }}
              semibold
              color="$textLink"
              display="inline"
            >
              {textInBrandColor}
            </Text>
          )}
        </Text>
      )}
    </RNView>
  );
}

export default SectionHeader;
